let isShowLog = 1;
const logs = (...values) => {
    if (isShowLog) {
        console.log('logs: ');
        console.log(values);
    }
}
export default logs;